import React from 'react';
import { isMobile } from 'react-device-detect';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import { Tooltip } from '@rcg/ui-react';
import IconDropDown from '../Icons/DropDown';
import useStyles from './index.style';
import { ReactComponent as InfoIcon } from '../../assets/svg/info.svg';

export default (props) => {
  // default props
  const defaultProps = {
    ...props,
    ...{ IconComponent: IconDropDown, disableUnderline: true, native: isMobile },
  };
  const classes = useStyles();
  const capitalizeStyle = (code) => {
    if (code === 'none') {
      return { display: 'none' };
    }
    return {};
  };

  const label = defaultProps.tooltip ? (
    <>
      <span className={classes.labelWithTooltipSelect}>
        {defaultProps.label}{' '}
        <span className={classes.tooltipLabel}>
          <Tooltip
            element={<InfoIcon />}
            content={<div className={classes.tooltipContent}>{defaultProps.tooltip}</div>}
          />
        </span>
      </span>
    </>
  ) : (
    defaultProps.label
  );

  return (
    <div className={classes.rootSelect}>
      <InputLabel shrink htmlFor={defaultProps.htmlFor} disabled={defaultProps.disabled}>
        {label}
      </InputLabel>
      <Select {...defaultProps} className={classes.select}>
        <MenuItem value="" disabled className={classes.itemTitle}>
          {defaultProps.placeholder}
        </MenuItem>
        {!defaultProps.loading && (
          <MenuItem value="" disabled>
            {defaultProps.loadingmessage}
          </MenuItem>
        )}
        {defaultProps.error && (
          <MenuItem value="" disabled>
            {defaultProps.errormessage}
          </MenuItem>
        )}
        {defaultProps.options &&
          defaultProps.options.map(({ code, name }) => {
            const shipName =
              name &&
              name.toLowerCase().replace(/(?:^|\s)(?!of|the|or)\S/g, (a) => {
                return a.toUpperCase();
              });
            return isMobile ? (
              <option value={code} key={code} style={capitalizeStyle(code)}>
                {shipName}
              </option>
            ) : (
              <MenuItem
                className={classes.item}
                value={code}
                key={code}
                style={capitalizeStyle(code)}>
                {shipName}
              </MenuItem>
            );
          })}
      </Select>
    </div>
  );
};
